import { Pipe, PipeTransform } from '@angular/core';
import { SICallTypes, SICallTypesDatabaseCode } from '../types/service-insight-types';

/**
 * Transforms a {@link SICallTypes} value into its user-friendly display label.
 *
 * Primarily used to convert plural service call type names into the singular
 * label displayed in the UI (for example, `Installations` → `Installation`).
 *
 * If the provided value does not have a configured mapping, an empty string
 * is returned.
 *
 * @param key The service call type to convert.
 * @returns The display label associated with the service call type.
 */
@Pipe({
    name: 'serviceCallTypeLabel',
    standalone: false
})
export class ServiceCallTypeLabelPipe implements PipeTransform {
  private readonly labelMap: Partial<Record<SICallTypes, string>> = {
    [SICallTypes.ExtraServiceVisit]: 'Extra Service Visit',
    [SICallTypes.TrainingSessions]: 'Training',
    [SICallTypes.RegularServiceCalls]: 'Regular Service Call',
    [SICallTypes.ProgramReviews]: 'Program Review',
    [SICallTypes.Installations]: 'Installation',
    [SICallTypes.QuickCalls]: 'Quick Call',
    [SICallTypes.Audit]: 'Audit',
  };

  transform(key: SICallTypes): string {
    return this.labelMap[key] || '';
  }
}
